import { render, staticRenderFns } from "./BlockAudioRecord.vue?vue&type=template&id=390868ee"
import script from "./BlockAudioRecord.vue?vue&type=script&lang=js"
export * from "./BlockAudioRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports